const CLIENT_ID = process.env.REACT_APP_OKTA_APPLICATION_ID;
const ISSUER = process.env.REACT_APP_OKTA_ISSUER_URL;
const OKTA_SETTING_URL = process.env.REACT_APP_OKTA_SETTING_URL;
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const END_SESSION_REDIRECT_URL = process.env.END_SESSION_REDIRECT_URL;
const REDIRECT_URI = `${window.location.origin}/login/callback`;
// const REDIRECT_URI = "https://id-qa.eaton.com/oauth2/aus18kyuno5D6fqcG0h8" || `${window.location.origin}/login/callback`;

export default {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    oktaSettingUrl: OKTA_SETTING_URL,
    redirectUri: REDIRECT_URI,
    endSessionRedirectUri: END_SESSION_REDIRECT_URL,
    discoveryUri: ISSUER,
    // The scopes associated with access tokens determine which claims are available when they are used to access the OIDC
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    grant_type:['refresh_token'],
    tokenManager: { storage: 'sessionStorage', autoRenew: true },
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    requireHardwareBackedKeyStore: false
};
